/**
 * Notification models for WebSocket push notifications (Frontend)
 */

export enum NotificationType {
  SYSTEM = "system",
  USER_UPDATE = "user_update",
  SUBSCRIPTION_UPDATE = "subscription_update",
  PROFILE_UPDATE = "profile_update",
  MEMBERS_ADDED = "members_added",
  MEMBERS_UPDATED = "members_updated",
  MEMBERS_DELETED = "members_deleted",
  TRAINEE_ADDED = "trainee_added",
  CHATS_UPDATED = "chats_updated",
  SESSIONS_UPDATED = "sessions_updated",
  TRAINEES_UPDATED = "trainees_updated",
  GUARDIANS_UPDATED = "guardians_updated",
  ANALYSIS_READY = "analysis_ready",
  SESSION_CREATED = "session_created",
  SESSION_FINISHED = "session_finished",
  ACCOUNT_UPGRADE = "account_upgrade",
  KYC_PENDING = "kyc_pending",
  SUBSCRIPTION_ENDING = "subscription_ending",
  SUBSCRIPTION_EXPIRED = "subscription_expired",
  PERSONALISATION_INCOMPLETE = "personalisation_incomplete",
  ONBOARDING_INCOMPLETE = "onboarding_incomplete",
  PAYMENT_SUCCESS = "payment_success",
  PAYMENT_FAILED = "payment_failed",
  RED_FLAG = "red_flag",
  ACCESS_SUSPENDED = "access_suspended",
}

export interface SystemNotification {
  type: NotificationType.SYSTEM;
  title: string;
  message: string;
  timestamp: Date | string;
  data?: Record<string, any>;
}

export interface UserUpdateNotification {
  type:
    | NotificationType.USER_UPDATE
    | NotificationType.PROFILE_UPDATE
    | NotificationType.SUBSCRIPTION_UPDATE;
  title: string;
  message: string;
  timestamp: Date | string;
  userId?: string;
  emailId?: string;
  updateType: "profile" | "subscription" | "premium_registration";
  data?: Record<string, any>;
}

export interface MembersAddedNotification {
  type: NotificationType.MEMBERS_ADDED;
  title: string;
  message: string;
  timestamp: Date | string;
  userId?: string;
  emailId?: string;
  data?: Record<string, any>;
}

export interface GenericDataNotification {
  type:
    | NotificationType.MEMBERS_UPDATED
    | NotificationType.MEMBERS_DELETED
    | NotificationType.CHATS_UPDATED
    | NotificationType.SESSIONS_UPDATED
    | NotificationType.TRAINEES_UPDATED
    | NotificationType.GUARDIANS_UPDATED;
  title: string;
  message: string;
  timestamp: Date | string;
  userId?: string;
  emailId?: string;
  data?: Record<string, any>;
}

export interface PersistedNotification {
  type: NotificationType | string;
  title: string;
  message: string;
  timestamp: Date | string;
  userId?: string;
  emailId?: string;
  data?: Record<string, any>;
}

export type NotificationPayload =
  | SystemNotification
  | UserUpdateNotification
  | MembersAddedNotification
  | GenericDataNotification
  | PersistedNotification;
